export default "https://cdn-static.gokick.com/assets/7e5886a8604a8a782ca6a0de4eecb197b7d69c39/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";